import { useRouter } from 'next/router';
import Image from '../Image';
import Link from 'next/link';
import { renderImageHandler } from '@/helpers/common/renderImage';

const CategoryCard = ({ itemData, fromCategories }) => {
  const { locale } = useRouter();
  const imgSrc = renderImageHandler(itemData, locale);
  return (
    <Link
      href={`/${!fromCategories ? itemData?.['category-url'] : itemData?.url_key}`}
      className='flex flex-col items-center justify-center gap-3 rounded-lg border p-2 pt-6 hover:bg-slate-50 md:gap-4 md:p-5 md:pt-8'
    >
      <Image
        src={
          !fromCategories
            ? imgSrc
            : itemData?.category_desktop_image1
              ? `${process.env.NEXT_PUBLIC_IMG_BASEURL}${itemData?.category_desktop_image1}`.replace('media', '')
              : '/imgs/img-placeholder.png'
        }
        className='h-auto max-h-10 min-h-10 w-auto min-w-10 max-w-10 object-contain sm:max-h-14 sm:min-h-14 sm:min-w-14 sm:max-w-14'
        loading='eager'
        alt={
          !fromCategories ? itemData?.[`title-${locale}`] : itemData?.name || ''
        }
      />
      <span className='text-center text-xs font-semibold max-sm:w-full max-sm:truncate sm:text-base md:min-h-12 md:text-lg'>
        {!fromCategories ? itemData?.[`title-${locale}`] : itemData?.name || ''}
      </span>
    </Link>
  );
};

export default CategoryCard;
